import { render } from "./CarruselOfertas.vue?vue&type=template&id=c01d6ba4&scoped=true"
import script from "./CarruselOfertas.vue?vue&type=script&lang=js"
export * from "./CarruselOfertas.vue?vue&type=script&lang=js"

import "./CarruselOfertas.vue?vue&type=style&index=0&id=c01d6ba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01d6ba4"]])

export default __exports__